export default {"src":"/_next/static/media/renterins.5708bca8.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};